(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-card-swiper"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.videoCardSwiperInitialized) {
      return;
    }

    window.videoCardSwiperInitialized = true;

    const selector = '[data-video-card-swiper]';

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const formatTime = (seconds, fallback) => {
      if (!Number.isFinite(seconds) || seconds < 0) {
        return fallback;
      }

      const rounded = Math.max(0, Math.floor(seconds));
      const minutes = Math.floor(rounded / 60);
      const remainder = rounded % 60;
      return `${minutes}:${String(remainder).padStart(2, '0')}`;
    };

    const setProgressRatio = (card, ratio) => {
      card.style.setProperty('--progress-ratio', clamp(ratio, 0, 1));
    };

    const getRealSlides = (track) => Array.from(track.querySelectorAll('[data-swiper-slide]:not([data-clone])'));

    const getClosestIndex = (viewport, slides) => {
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;
      const reference = viewport.scrollLeft;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - reference);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const scrollToIndex = (viewport, slides, index, behavior) => {
      const slideCount = slides.length;
      if (!slideCount) {
        return;
      }

      const normalized = ((index % slideCount) + slideCount) % slideCount;
      const target = slides[normalized];
      if (!target) {
        return;
      }

      viewport.scrollTo({
        left: target.offsetLeft,
        behavior,
      });
    };

    const setupVideoCard = (card, root) => {
      const video = card.querySelector('video');
      if (!video) {
        return;
      }

      const toggle = card.querySelector('[data-video-toggle]');
      const currentTime = card.querySelector('[data-current-time]');
      const duration = card.querySelector('[data-duration]');
      const fallbackCurrent = card.dataset.fallbackCurrent || '0:01';
      const fallbackDuration = card.dataset.fallbackDuration || '0:24';

      video.muted = root.dataset.muteVideos === 'true';
      video.defaultMuted = video.muted;

      currentTime.textContent = fallbackCurrent;
      duration.textContent = fallbackDuration;

      const updateTime = () => {
        if (Number.isFinite(video.duration) && video.duration > 0) {
          duration.textContent = formatTime(video.duration, fallbackDuration);
          currentTime.textContent = formatTime(video.currentTime, fallbackCurrent);
          setProgressRatio(card, video.currentTime / video.duration);
        }
      };

      const pauseOtherVideos = () => {
        if (root.dataset.pauseOthers !== 'true') {
          return;
        }

        document.querySelectorAll(`${selector} video`).forEach((otherVideo) => {
          if (otherVideo !== video) {
            otherVideo.pause();
          }
        });
      };

      const togglePlayback = () => {
        if (video.paused) {
          pauseOtherVideos();
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        } else {
          video.pause();
        }
      };

      toggle.addEventListener('click', togglePlayback);
      card.addEventListener('click', (event) => {
        if (event.target.closest('[data-video-toggle]')) {
          return;
        }
        togglePlayback();
      });

      video.addEventListener('loadedmetadata', updateTime);
      video.addEventListener('timeupdate', updateTime);
      video.addEventListener('play', () => {
        card.classList.add('is-playing');
      });
      video.addEventListener('pause', () => {
        card.classList.remove('is-playing');
      });
      video.addEventListener('ended', () => {
        video.currentTime = 0;
        currentTime.textContent = fallbackCurrent;
        card.classList.remove('is-playing');
        setProgressRatio(card, 0);
      });
    };

    const enhanceInfiniteLoop = (viewport, track, slides) => {
      if (slides.length < 2) {
        return {
          normalize: () => {},
        };
      }

      const cloneCount = Math.min(2, slides.length);
      const clonesBefore = slides.slice(-cloneCount).map((slide) => {
        const clone = slide.cloneNode(true);
        clone.dataset.clone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        return clone;
      });
      const clonesAfter = slides.slice(0, cloneCount).map((slide) => {
        const clone = slide.cloneNode(true);
        clone.dataset.clone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        return clone;
      });

      clonesBefore.reverse().forEach((clone) => {
        track.insertBefore(clone, track.firstChild);
      });

      clonesAfter.forEach((clone) => {
        track.appendChild(clone);
      });

      requestAnimationFrame(() => {
        viewport.scrollLeft = slides[0].offsetLeft;
      });

      const normalize = () => {
        const firstReal = slides[0];
        const lastReal = slides[slides.length - 1];
        const step = slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : firstReal.offsetWidth;
        const realSpan = lastReal.offsetLeft - firstReal.offsetLeft + step;

        if (viewport.scrollLeft < firstReal.offsetLeft - step / 2) {
          viewport.scrollLeft += realSpan;
        } else if (viewport.scrollLeft > lastReal.offsetLeft + step / 2) {
          viewport.scrollLeft -= realSpan;
        }
      };

      return { normalize };
    };

    const initSection = (root) => {
      if (root.dataset.initialized === 'true') {
        return;
      }

      const viewport = root.querySelector('[data-swiper-viewport]');
      const track = root.querySelector('[data-swiper-track]');

      if (!viewport || !track) {
        return;
      }

      const slides = getRealSlides(track);
      if (!slides.length) {
        return;
      }

      root.dataset.initialized = 'true';

      slides.forEach((card) => setupVideoCard(card, root));

      const infiniteEnabled = root.dataset.infinite === 'true';
      const loop = infiniteEnabled ? enhanceInfiniteLoop(viewport, track, slides) : { normalize: () => {} };
      const prevButton = root.querySelector('[data-swiper-prev]');
      const nextButton = root.querySelector('[data-swiper-next]');

      const updateButtons = () => {
        if (infiniteEnabled || !prevButton || !nextButton) {
          return;
        }

        const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth - 2;
        prevButton.disabled = viewport.scrollLeft <= 2;
        nextButton.disabled = viewport.scrollLeft >= maxScrollLeft;
      };

      const goToSlide = (direction) => {
        const currentIndex = getClosestIndex(viewport, slides);
        const nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;

        if (infiniteEnabled) {
          scrollToIndex(viewport, slides, nextIndex, 'smooth');
        } else {
          scrollToIndex(viewport, slides, clamp(nextIndex, 0, slides.length - 1), 'smooth');
        }
      };

      if (prevButton) {
        prevButton.addEventListener('click', () => goToSlide('prev'));
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => goToSlide('next'));
      }

      let normalizeTimer;

      viewport.addEventListener(
        'scroll',
        () => {
          updateButtons();
          if (!infiniteEnabled) {
            return;
          }

          window.clearTimeout(normalizeTimer);
          normalizeTimer = window.setTimeout(() => {
            loop.normalize();
          }, 80);
        },
        { passive: true }
      );

      window.addEventListener('resize', () => {
        loop.normalize();
        updateButtons();
      });

      updateButtons();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach((root) => initSection(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
